import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "form-designer"
};
const _hoisted_2 = {
  class: "field-panel"
};
const _hoisted_3 = {
  class: "panel-content overflow-y-auto p-3"
};
const _hoisted_4 = {
  class: "space-y-2"
};
const _hoisted_5 = ["onDragstart"];
const _hoisted_6 = {
  class: "flex-1"
};
const _hoisted_7 = {
  class: "text-sm font-medium text-slate-800"
};
const _hoisted_8 = {
  class: "text-xs text-slate-500"
};
const _hoisted_9 = {
  class: "canvas-panel"
};
const _hoisted_10 = {
  class: "panel-header px-4 py-3 bg-white border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_11 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_12 = {
  class: "flex gap-2"
};
const _hoisted_13 = {
  class: "canvas-content flex-1 overflow-auto p-6 min-h-0"
};
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center h-80 text-slate-400"
};
const _hoisted_15 = {
  class: "text-center"
};
const _hoisted_16 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity"
};
const _hoisted_19 = ["onClick", "disabled"];
const _hoisted_20 = ["onClick", "disabled"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "pr-24"
};
const _hoisted_23 = {
  class: "block text-sm font-medium text-slate-700 mb-1"
};
const _hoisted_24 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_25 = {
  key: 0,
  class: "text-xs text-slate-500 mb-2"
};
const _hoisted_26 = {
  class: "mt-2"
};
const _hoisted_27 = ["onDrop"];
const _hoisted_28 = {
  class: "space-y-2 min-h-16"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  class: "text-sm text-slate-700 flex-1 truncate"
};
const _hoisted_31 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_32 = {
  key: 0,
  class: "text-xs text-primary-500 shrink-0"
};
const _hoisted_33 = {
  class: "flex gap-1 opacity-0 group-hover/child:opacity-100 transition-opacity shrink-0"
};
const _hoisted_34 = ["onClick", "disabled"];
const _hoisted_35 = ["onClick", "disabled"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0,
  class: "text-center text-xs text-slate-400 py-4"
};
const _hoisted_38 = {
  class: "text-xs text-slate-400 mt-2"
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = ["placeholder"];
const _hoisted_41 = ["placeholder"];
const _hoisted_42 = ["placeholder", "rows"];
const _hoisted_43 = {
  key: 4,
  type: "date",
  class: "form-input w-full",
  disabled: ""
};
const _hoisted_44 = {
  key: 6,
  class: "space-y-2"
};
const _hoisted_45 = ["name", "value"];
const _hoisted_46 = {
  key: 7,
  class: "space-y-2"
};
const _hoisted_47 = ["value"];
const _hoisted_48 = {
  key: 8,
  class: "border-2 border-dashed border-slate-300 rounded-lg p-4 text-center bg-slate-50"
};
const _hoisted_49 = {
  key: 0,
  class: "props-panel"
};
const _hoisted_50 = {
  class: "panel-header px-4 py-3 border-b border-slate-200 bg-slate-50 flex items-center justify-between"
};
const _hoisted_51 = {
  class: "panel-content flex-1 overflow-y-auto p-4"
};
const _hoisted_52 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
};
const _hoisted_53 = {
  key: 1,
  class: "text-xs text-green-600 mt-1"
};
const _hoisted_54 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_55 = {
  class: "text-xs font-medium text-slate-700"
};
const _hoisted_56 = {
  class: "w-full space-y-2"
};
const _hoisted_57 = {
  class: "flex items-center justify-between"
};
const _hoisted_58 = {
  class: "text-xs font-medium text-slate-600"
};
const _hoisted_59 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_60 = {
  class: "dialog-header"
};
const _hoisted_61 = {
  class: "header-content"
};
const _hoisted_62 = {
  class: "preview-content"
};
const _hoisted_63 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_64 = {
  key: 1,
  class: "form-fields-wrapper"
};
const _hoisted_65 = {
  class: "form-header-info"
};
const _hoisted_66 = {
  class: "form-title"
};
const _hoisted_67 = {
  class: "field-count"
};
const _hoisted_68 = {
  class: "label-text"
};
const _hoisted_69 = {
  key: 0,
  class: "required-mark"
};
const _hoisted_70 = {
  key: 0,
  class: "field-placeholder"
};
const _hoisted_71 = {
  class: "upload-content"
};
const _hoisted_72 = {
  class: "upload-tip"
};
const _hoisted_73 = {
  key: 11,
  class: "border-2 border-dashed border-slate-300 rounded-lg p-4 bg-slate-50"
};
const _hoisted_74 = {
  class: "text-sm text-slate-500"
};
const _hoisted_75 = {
  class: "dialog-footer"
};
import { ref, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { Edit, Calendar, List, Document, Upload, Money, Phone, Message as MessageIcon, View, DocumentChecked, DocumentAdd, Close, Delete, ArrowUp, ArrowDown, Plus, UploadFilled, Switch, Link, Tickets } from '@element-plus/icons-vue';
import { DETAIL_CHILD_TYPES, isDetailField, validateComputedExpression } from '@/utils/workflowDetail';

// Props

export default {
  __name: 'FormDesigner',
  props: {
    initialForm: {
      type: Object,
      default: () => null
    }
  },
  emits: ['save', 'update'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;

    // Emits
    const emit = __emit;

    // 表单基本信息
    const formName = ref(props.initialForm?.name || '新建表单');
    const formFields = ref(props.initialForm?.fields || []);
    const selectedField = ref(null);
    // 选中子字段时记录其所属 DETAIL 容器；选中顶层字段/容器时为 null
    const selectedFieldParent = ref(null);
    const previewVisible = ref(false);

    // 监听 initialForm 变化，同步数据
    watch(() => props.initialForm, newForm => {
      if (newForm) {
        formName.value = newForm.name || '新建表单';
        formFields.value = newForm.fields || [];
      }
    }, {
      immediate: true
    });

    // 字段类型定义
    const fieldTypes = [{
      type: 'TEXT',
      label: '单行文本',
      description: '短文本输入',
      icon: Edit,
      iconClass: 'text-blue-600'
    }, {
      type: 'TEXTAREA',
      label: '多行文本',
      description: '长文本输入',
      icon: Document,
      iconClass: 'text-blue-600'
    }, {
      type: 'NUMBER',
      label: '数字',
      description: '数值输入',
      icon: Edit,
      iconClass: 'text-green-600'
    }, {
      type: 'MONEY',
      label: '金额',
      description: '货币金额',
      icon: Money,
      iconClass: 'text-green-600'
    }, {
      type: 'DETAIL',
      label: '组合表单',
      description: '嵌套子表单',
      icon: Tickets,
      iconClass: 'text-rose-600'
    }, {
      type: 'DATE',
      label: '日期',
      description: '日期选择',
      icon: Calendar,
      iconClass: 'text-purple-600'
    }, {
      type: 'DATETIME',
      label: '日期时间',
      description: '日期时间选择',
      icon: Calendar,
      iconClass: 'text-purple-600'
    }, {
      type: 'SELECT',
      label: '下拉选择',
      description: '单项选择',
      icon: List,
      iconClass: 'text-orange-600'
    }, {
      type: 'RADIO',
      label: '单选框',
      description: '单项选择',
      icon: List,
      iconClass: 'text-orange-600'
    }, {
      type: 'CHECKBOX',
      label: '多选框',
      description: '多项选择',
      icon: List,
      iconClass: 'text-orange-600'
    }, {
      type: 'EMAIL',
      label: '邮箱',
      description: '邮箱地址',
      icon: MessageIcon,
      iconClass: 'text-cyan-600'
    }, {
      type: 'PHONE',
      label: '手机号',
      description: '手机号码',
      icon: Phone,
      iconClass: 'text-cyan-600'
    }, {
      type: 'FILE',
      label: '文件上传',
      description: '附件上传',
      icon: Upload,
      iconClass: 'text-red-600'
    }, {
      type: 'SWITCH',
      label: '开关',
      description: '是/否切换',
      icon: Switch,
      iconClass: 'text-teal-600'
    }, {
      type: 'URL',
      label: '链接',
      description: 'URL 地址',
      icon: Link,
      iconClass: 'text-indigo-600'
    }];

    // 拖拽开始
    function onFieldDragStart(event, fieldType) {
      event.dataTransfer.setData('fieldType', JSON.stringify(fieldType));
    }

    // 放置字段
    function onFieldDrop(event) {
      const fieldTypeData = event.dataTransfer.getData('fieldType');
      if (!fieldTypeData) return;
      const fieldType = JSON.parse(fieldTypeData);
      const newField = createField(fieldType.type);
      formFields.value.push(newField);
      selectedField.value = newField;
      selectedFieldParent.value = null;
      ElMessage.success(`已添加${fieldType.label}字段`);
    }

    // 创建字段
    function createField(type) {
      const fieldCount = formFields.value.filter(f => f.type === type).length;
      const baseField = {
        id: `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        type,
        key: `${type.toLowerCase()}_${fieldCount + 1}`,
        label: `${getFieldTypeLabel(type)}${fieldCount + 1}`,
        placeholder: '',
        required: false,
        validation: '',
        validationMessage: ''
      };

      // 根据类型添加特定配置
      if (['SELECT', 'RADIO', 'CHECKBOX'].includes(type)) {
        baseField.options = [{
          label: '选项1',
          value: 'option1'
        }, {
          label: '选项2',
          value: 'option2'
        }];
      }
      if (type === 'TEXT') {
        baseField.maxLength = 100;
      }
      if (type === 'TEXTAREA') {
        baseField.rows = 3;
      }
      if (['NUMBER', 'MONEY'].includes(type)) {
        baseField.min = null;
        baseField.max = null;
      }
      if (type === 'FILE') {
        baseField.accept = '';
        baseField.maxSize = 10;
        baseField.maxCount = 1;
      }
      if (type === 'DETAIL') {
        baseField.minRows = 1;
        baseField.maxRows = null;
        baseField.summary = [];
        // 预置两个示例子字段：名称 TEXT + 金额 MONEY
        baseField.children = [];
      }
      return baseField;
    }

    // 选择字段（子字段需传入所属 DETAIL 容器）
    function selectField(field, parent = null) {
      selectedField.value = field;
      selectedFieldParent.value = parent;
    }

    // 移除字段
    function removeField(index) {
      const removed = formFields.value[index];
      formFields.value.splice(index, 1);
      // 被删字段本身是选中字段，或选中字段是被删容器 children 中的一员时，清理选中态
      const isSelectedRemoved = selectedField.value && removed && (selectedField.value.id === removed.id || Array.isArray(removed.children) && removed.children.some(c => c.id === selectedField.value.id));
      if (isSelectedRemoved) {
        selectedField.value = null;
        selectedFieldParent.value = null;
      }
      ElMessage.success('字段已删除');
    }

    // 向 DETAIL 容器内放置子字段（独立 drop zone，禁止嵌套 DETAIL）
    function onChildFieldDrop(event, detailField) {
      const fieldTypeData = event.dataTransfer.getData('fieldType');
      if (!fieldTypeData) return;
      const fieldType = JSON.parse(fieldTypeData);
      if (fieldType.type === 'DETAIL') {
        ElMessage.warning('明细表内不能再嵌套明细表');
        return;
      }
      // 子字段类型白名单：与后端模板保存校验一致（spec 3.2），SWITCH/URL 等不可作为明细列
      if (!DETAIL_CHILD_TYPES.includes(fieldType.type)) {
        ElMessage.warning(`${fieldType.label}不能作为明细列`);
        return;
      }
      if (!Array.isArray(detailField.children)) {
        detailField.children = [];
      }
      const newField = createField(fieldType.type);
      // 子字段 key 按容器内序号递增探测，此处保证生成即唯一；用户手改 key 的唯一性由保存前校验兜底（Task 5）
      let seq = detailField.children.length + 1;
      let childKey = `${fieldType.type.toLowerCase()}_${seq}`;
      while (detailField.children.some(c => c.key === childKey)) {
        seq += 1;
        childKey = `${fieldType.type.toLowerCase()}_${seq}`;
      }
      newField.key = childKey;
      newField.label = `${getFieldTypeLabel(fieldType.type)}${seq}`;
      detailField.children.push(newField);
      selectedField.value = newField;
      selectedFieldParent.value = detailField;
      ElMessage.success(`已添加${fieldType.label}列`);
    }

    // 上移子字段
    function moveChildFieldUp(detailField, index) {
      if (index === 0) return;
      const children = detailField.children;
      const temp = children[index];
      children[index] = children[index - 1];
      children[index - 1] = temp;
    }

    // 下移子字段
    function moveChildFieldDown(detailField, index) {
      const children = detailField.children;
      if (index === children.length - 1) return;
      const temp = children[index];
      children[index] = children[index + 1];
      children[index + 1] = temp;
    }

    // 删除子字段
    function removeChildField(detailField, index) {
      const removed = detailField.children[index];
      detailField.children.splice(index, 1);
      if (selectedField.value && removed && selectedField.value.id === removed.id) {
        selectedField.value = null;
        selectedFieldParent.value = null;
      }
      ElMessage.success('列已删除');
    }

    // 上移字段
    function moveFieldUp(index) {
      if (index === 0) return;
      const temp = formFields.value[index];
      formFields.value[index] = formFields.value[index - 1];
      formFields.value[index - 1] = temp;
    }

    // 下移字段
    function moveFieldDown(index) {
      if (index === formFields.value.length - 1) return;
      const temp = formFields.value[index];
      formFields.value[index] = formFields.value[index + 1];
      formFields.value[index + 1] = temp;
    }

    // 添加选项
    function addOption() {
      if (!selectedField.value || !selectedField.value.options) return;
      const optionCount = selectedField.value.options.length;
      selectedField.value.options.push({
        label: `选项${optionCount + 1}`,
        value: `option${optionCount + 1}`
      });
    }

    // 删除选项
    function removeOption(index) {
      if (!selectedField.value || !selectedField.value.options) return;
      if (selectedField.value.options.length <= 1) {
        ElMessage.warning('至少保留一个选项');
        return;
      }
      selectedField.value.options.splice(index, 1);
    }

    // 获取字段类型标签
    function getFieldTypeLabel(type) {
      const fieldType = fieldTypes.find(f => f.type === type);
      return fieldType ? fieldType.label : type;
    }

    // DETAIL 容器内的数值/金额列（summary 配置可选列）
    function detailNumericChildren(field) {
      return (field?.children || []).filter(c => ['NUMBER', 'MONEY'].includes(c.type));
    }

    // 添加一条列合计配置（aggregate 第一版固定 SUM）
    function addSummary() {
      if (!selectedField.value || selectedField.value.type !== 'DETAIL') return;
      if (!Array.isArray(selectedField.value.summary)) {
        selectedField.value.summary = [];
      }
      const firstNumeric = detailNumericChildren(selectedField.value)[0];
      selectedField.value.summary.push({
        column: firstNumeric?.key || '',
        aggregate: 'SUM',
        targetKey: '',
        label: ''
      });
    }

    // 删除一条列合计配置
    function removeSummary(index) {
      selectedField.value?.summary?.splice(index, 1);
    }

    // 子字段 computed 表达式实时语法校验（仅容器内 NUMBER/MONEY 子字段）
    const computedExprError = computed(() => {
      if (!selectedFieldParent.value || !selectedField.value?.computed) return '';
      return validateComputedExpression(selectedField.value.computed, selectedFieldParent.value.children);
    });

    // 预览表单
    function previewForm() {
      if (formFields.value.length === 0) {
        ElMessage.warning('请先添加表单字段');
        return;
      }
      previewVisible.value = true;
    }

    // 保存表单
    function saveForm() {
      if (formFields.value.length === 0) {
        ElMessage.warning('请先添加表单字段');
        return;
      }
      const detailError = validateDetailFields();
      if (detailError) {
        ElMessage.error(detailError);
        return;
      }
      const formData = {
        name: formName.value,
        fields: formFields.value
      };
      emit('save', formData);
      ElMessage.success('表单保存成功');
    }

    // 保存前校验：与后端模板保存校验同规则（spec 4.3）
    function validateDetailFields() {
      const fields = formFields.value;
      const topKeys = new Set();
      for (const field of fields) {
        if (!field.key || !field.key.trim()) {
          return `字段"${field.label}"缺少字段标识`;
        }
        if (topKeys.has(field.key)) {
          return `字段标识 "${field.key}" 重复`;
        }
        topKeys.add(field.key);
      }
      const targetKeys = new Set();
      for (const field of fields) {
        if (!isDetailField(field)) continue;
        const children = field.children || [];
        if (children.length === 0) {
          return `明细表"${field.label}"至少需要一列`;
        }
        const childKeys = new Set();
        for (const child of children) {
          if (isDetailField(child)) {
            return `明细表"${field.label}"内不能嵌套明细表`;
          }
          // 白名单兜底：拖放入口之外的防线（如历史数据/手改 type）
          if (!DETAIL_CHILD_TYPES.includes(child.type)) {
            return `明细表"${field.label}"列"${child.label}"的类型不支持作为明细列`;
          }
          if (!child.key || !child.key.trim()) {
            return `明细表"${field.label}"存在缺少标识的列`;
          }
          if (childKeys.has(child.key)) {
            return `明细表"${field.label}"列标识 "${child.key}" 重复`;
          }
          childKeys.add(child.key);
          if (child.computed) {
            // computed 子字段必须为 NUMBER/MONEY（与后端 validateComputed 对齐）
            if (!['NUMBER', 'MONEY'].includes(child.type)) {
              return `明细表"${field.label}"列"${child.label}"：计算公式仅支持数字/金额列`;
            }
            const error = validateComputedExpression(child.computed, children);
            if (error) {
              return `明细表"${field.label}"列"${child.label}"：${error}`;
            }
            // computed 子字段强制只读（spec 3.2）
            child.readonly = true;
          }
        }
        const minRows = Number(field.minRows ?? 0);
        if (!Number.isFinite(minRows) || minRows < 0) {
          return `明细表"${field.label}"最小行数不能小于 0`;
        }
        if (field.maxRows !== null && field.maxRows !== undefined && field.maxRows !== '') {
          const maxRows = Number(field.maxRows);
          if (!Number.isFinite(maxRows) || maxRows < Math.max(minRows, 1)) {
            return `明细表"${field.label}"最大行数需不小于 ${Math.max(minRows, 1)}`;
          }
        }
        for (const sum of field.summary || []) {
          const column = children.find(c => c.key === sum.column);
          if (!column || !['NUMBER', 'MONEY'].includes(column.type)) {
            return `明细表"${field.label}"的合计列必须是数值/金额列`;
          }
          if (!sum.targetKey || !sum.targetKey.trim()) {
            return `明细表"${field.label}"的合计缺少字段标识`;
          }
          if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(sum.targetKey)) {
            return `合计标识 "${sum.targetKey}" 必须是合法标识符（字母或下划线开头，仅含字母数字下划线）`;
          }
          if (sum.targetKey.startsWith('__workflow')) {
            return `合计标识 "${sum.targetKey}" 不能以 __workflow 开头`;
          }
          if (topKeys.has(sum.targetKey)) {
            return `合计标识 "${sum.targetKey}" 与顶层字段重复`;
          }
          if (targetKeys.has(sum.targetKey)) {
            return `合计标识 "${sum.targetKey}" 重复`;
          }
          targetKeys.add(sum.targetKey);
        }
      }
      return '';
    }

    // 获取表单数据（供父组件调用）
    const getFormData = () => {
      return {
        name: formName.value,
        fields: formFields.value
      };
    };

    // 获取字段列表（供流程设计器使用；DETAIL 需携带 summary 以展开合计字段）
    const getFieldList = () => {
      return formFields.value.map(field => ({
        key: field.key,
        label: field.label,
        type: field.type,
        summary: field.summary || []
      }));
    };

    // 暴露方法给父组件
    __expose({
      getFormData,
      getFieldList
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "panel-header"
      }, [_createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-700"
      }, "表单字段")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(fieldTypes, fieldType => {
        return _createElementVNode("div", {
          key: fieldType.type,
          class: "flex items-center gap-2 px-3 py-2.5 bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-primary-300 rounded-lg cursor-grab active:cursor-grabbing transition-all",
          draggable: "true",
          onDragstart: $event => onFieldDragStart($event, fieldType)
        }, [_createVNode(_component_el_icon, {
          size: 16,
          class: _normalizeClass(fieldType.iconClass)
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(fieldType.icon)))]),
          _: 2
        }, 1032, ["class"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(fieldType.label), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(fieldType.description), 1)])], 40, _hoisted_5);
      }), 64))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h3", _hoisted_11, _toDisplayString(formName.value || '未命名表单'), 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        size: "small",
        onClick: previewForm
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(View))]),
          _: 1
        }), _cache[22] || (_cache[22] = _createTextVNode(" 预览 ", -1))]),
        _: 1
      }), _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: saveForm
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(DocumentChecked))]),
          _: 1
        }), _cache[23] || (_cache[23] = _createTextVNode(" 保存 ", -1))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-slate-200 p-6 min-h-96",
        onDrop: onFieldDrop,
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [formFields.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_icon, {
        size: 48,
        class: "mb-2"
      }, {
        default: _withCtx(() => [_createVNode(_unref(DocumentAdd))]),
        _: 1
      }), _cache[24] || (_cache[24] = _createElementVNode("p", {
        class: "text-sm"
      }, "从左侧拖拽字段到此处开始设计表单", -1))])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value, (field, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: field.id,
          class: _normalizeClass(["group relative p-4 border rounded-lg transition-all", [selectedField.value?.id === field.id ? 'border-primary-400 bg-primary-50' : 'border-slate-200 hover:border-slate-300 bg-white']]),
          onClick: $event => selectField(field)
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50",
          onClick: _withModifiers($event => moveFieldUp(index), ["stop"]),
          disabled: index === 0
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_19), _createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50",
          onClick: _withModifiers($event => moveFieldDown(index), ["stop"]),
          disabled: index === formFields.value.length - 1
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_20), _createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          onClick: _withModifiers($event => removeField(index), ["stop"])
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("label", _hoisted_23, [_createTextVNode(_toDisplayString(field.label) + " ", 1), field.required ? (_openBlock(), _createElementBlock("span", _hoisted_24, "*")) : _createCommentVNode("", true)]), field.placeholder ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(field.placeholder), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [field.type === 'DETAIL' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "border-2 border-dashed border-slate-300 rounded-lg p-3 bg-slate-50/50",
          onDrop: _withModifiers($event => onChildFieldDrop($event, field), ["stop"]),
          onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [_createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], (child, childIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: child.id,
            class: _normalizeClass(["group/child relative flex items-center gap-2 p-2 bg-white border rounded cursor-pointer transition-all", selectedField.value?.id === child.id ? 'border-primary-400 bg-primary-50' : 'border-slate-200 hover:border-slate-300']),
            onClick: _withModifiers($event => selectField(child, field), ["stop"])
          }, [_createVNode(_component_el_tag, {
            size: "small",
            class: "shrink-0"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getFieldTypeLabel(child.type)), 1)]),
            _: 2
          }, 1024), _createElementVNode("span", _hoisted_30, [_createTextVNode(_toDisplayString(child.label), 1), child.required ? (_openBlock(), _createElementBlock("span", _hoisted_31, "*")) : _createCommentVNode("", true)]), child.computed ? (_openBlock(), _createElementBlock("span", _hoisted_32, "= " + _toDisplayString(child.computed), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [_createElementVNode("button", {
            class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50",
            onClick: _withModifiers($event => moveChildFieldUp(field, childIndex), ["stop"]),
            disabled: childIndex === 0
          }, [_createVNode(_component_el_icon, {
            size: 12
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
            _: 1
          })], 8, _hoisted_34), _createElementVNode("button", {
            class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50",
            onClick: _withModifiers($event => moveChildFieldDown(field, childIndex), ["stop"]),
            disabled: childIndex === (field.children || []).length - 1
          }, [_createVNode(_component_el_icon, {
            size: 12
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
            _: 1
          })], 8, _hoisted_35), _createElementVNode("button", {
            class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
            onClick: _withModifiers($event => removeChildField(field, childIndex), ["stop"])
          }, [_createVNode(_component_el_icon, {
            size: 12
          }, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          })], 8, _hoisted_36)])], 10, _hoisted_29);
        }), 128)), !(field.children || []).length ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 从左侧拖拽字段到此处作为明细列 ")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_38, [_createTextVNode(" 行数：" + _toDisplayString(field.minRows ?? 0) + " ~ " + _toDisplayString(field.maxRows ?? '不限'), 1), (field.summary || []).length ? (_openBlock(), _createElementBlock("span", _hoisted_39, "；合计 " + _toDisplayString(field.summary.length) + " 列", 1)) : _createCommentVNode("", true)])], 40, _hoisted_27)) : field.type === 'TEXT' || field.type === 'EMAIL' || field.type === 'PHONE' || field.type === 'URL' ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          placeholder: field.placeholder,
          class: "form-input w-full",
          disabled: ""
        }, null, 8, _hoisted_40)) : field.type === 'NUMBER' || field.type === 'MONEY' ? (_openBlock(), _createElementBlock("input", {
          key: 2,
          type: "number",
          placeholder: field.placeholder,
          class: "form-input w-full",
          disabled: ""
        }, null, 8, _hoisted_41)) : field.type === 'TEXTAREA' ? (_openBlock(), _createElementBlock("textarea", {
          key: 3,
          placeholder: field.placeholder,
          rows: field.rows || 3,
          class: "form-textarea form-control-sm",
          disabled: ""
        }, null, 8, _hoisted_42)) : field.type === 'DATE' || field.type === 'DATETIME' ? (_openBlock(), _createElementBlock("input", _hoisted_43)) : field.type === 'SELECT' ? (_openBlock(), _createBlock(_component_el_select, {
          key: 5,
          class: "form-select w-full",
          placeholder: field.placeholder || '请选择',
          disabled: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: opt.value,
              label: opt.label,
              value: opt.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["placeholder"])) : field.type === 'RADIO' ? (_openBlock(), _createElementBlock("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
          return _openBlock(), _createElementBlock("label", {
            key: opt.value,
            class: "flex items-center gap-2 text-sm text-slate-700"
          }, [_createElementVNode("input", {
            type: "radio",
            name: field.key,
            value: opt.value,
            disabled: "",
            class: "text-primary-600"
          }, null, 8, _hoisted_45), _createTextVNode(" " + _toDisplayString(opt.label), 1)]);
        }), 128))])) : field.type === 'CHECKBOX' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
          return _openBlock(), _createElementBlock("label", {
            key: opt.value,
            class: "flex items-center gap-2 text-sm text-slate-700"
          }, [_createElementVNode("input", {
            type: "checkbox",
            value: opt.value,
            disabled: "",
            class: "text-primary-600"
          }, null, 8, _hoisted_47), _createTextVNode(" " + _toDisplayString(opt.label), 1)]);
        }), 128))])) : field.type === 'FILE' ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createVNode(_component_el_icon, {
          size: 32,
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Upload))]),
          _: 1
        }), _cache[25] || (_cache[25] = _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-2"
        }, "点击上传或拖拽文件到此处", -1))])) : field.type === 'SWITCH' ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 9,
          disabled: ""
        })) : _createCommentVNode("", true)])])], 10, _hoisted_17);
      }), 128))]))], 32)])]), selectedField.value ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_cache[26] || (_cache[26] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-700"
      }, "字段属性", -1)), _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = $event => selectedField.value = null),
        class: "text-slate-400 hover:text-slate-600"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_el_form, {
        "label-position": "top",
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "字段标识"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.key,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedField.value.key = $event),
            placeholder: "用于数据存储的唯一标识"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "字段标签"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.label,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedField.value.label = $event),
            placeholder: "显示给用户的标签"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), selectedField.value.type !== 'DETAIL' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "占位提示"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.placeholder,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectedField.value.placeholder = $event),
            placeholder: "输入框的提示文字"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "字段类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getFieldTypeLabel(selectedField.value.type)), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "是否必填"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedField.value.required,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => selectedField.value.required = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), selectedField.value.type === 'TEXT' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "最大长度"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.maxLength,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => selectedField.value.maxLength = $event),
            min: 1,
            max: 1000,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), selectedField.value.type === 'TEXTAREA' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: "行数"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.rows,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => selectedField.value.rows = $event),
            min: 2,
            max: 10,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), selectedField.value.type === 'NUMBER' || selectedField.value.type === 'MONEY' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          label: "最小值"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.min,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => selectedField.value.min = $event),
            controls: false,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), selectedField.value.type === 'NUMBER' || selectedField.value.type === 'MONEY' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 4,
          label: "最大值"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.max,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => selectedField.value.max = $event),
            controls: false,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), selectedFieldParent.value && ['NUMBER', 'MONEY'].includes(selectedField.value.type) ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 5,
          label: "计算公式（可选）"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.computed,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => selectedField.value.computed = $event),
            placeholder: "如: amount * qty，仅可引用本行数值列"
          }, null, 8, ["modelValue"]), computedExprError.value ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(computedExprError.value), 1)) : selectedField.value.computed ? (_openBlock(), _createElementBlock("p", _hoisted_53, "表达式合法，该列将只读自动计算")) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), ['SELECT', 'RADIO', 'CHECKBOX'].includes(selectedField.value.type) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 6
        }, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("选项配置", -1)]))]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedField.value.options, (option, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-3 p-3 bg-slate-50 rounded-lg"
          }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, "选项 " + _toDisplayString(index + 1), 1), _createVNode(_component_el_button, {
            type: "danger",
            link: "",
            size: "small",
            onClick: $event => removeOption(index),
            disabled: selectedField.value.options.length <= 1
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" 删除 ", -1)]))]),
            _: 1
          }, 8, ["onClick", "disabled"])]), _createVNode(_component_el_form_item, {
            label: "选项标签"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: option.label,
              "onUpdate:modelValue": $event => option.label = $event,
              placeholder: "显示文本",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024), _createVNode(_component_el_form_item, {
            label: "选项值"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: option.value,
              "onUpdate:modelValue": $event => option.value = $event,
              placeholder: "实际值",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024)]);
        }), 128)), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          class: "w-full",
          onClick: addOption
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          }), _cache[29] || (_cache[29] = _createTextVNode(" 添加选项 ", -1))]),
          _: 1
        })], 64)) : _createCommentVNode("", true), selectedField.value.type === 'FILE' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 7
        }, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("上传配置", -1)]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "允许的文件类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.accept,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => selectedField.value.accept = $event),
            placeholder: "如: .jpg,.png,.pdf"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最大文件大小(MB)"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.maxSize,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => selectedField.value.maxSize = $event),
            min: 1,
            max: 100,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最多上传数量"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.maxCount,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => selectedField.value.maxCount = $event),
            min: 1,
            max: 10,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true), selectedField.value.type !== 'DETAIL' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 8
        }, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("验证规则", -1)]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "自定义验证"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.validation,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => selectedField.value.validation = $event),
            type: "textarea",
            rows: 2,
            placeholder: "正则表达式，如: ^[0-9]{11}$"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "验证提示"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedField.value.validationMessage,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => selectedField.value.validationMessage = $event),
            placeholder: "验证失败时的提示信息"
          }, null, 8, ["modelValue"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true), selectedField.value.type === 'DETAIL' && !selectedFieldParent.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 9
        }, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("明细表配置", -1)]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最小行数"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.minRows,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => selectedField.value.minRows = $event),
            min: 0,
            max: 999,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最大行数（留空不限）"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedField.value.maxRows,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => selectedField.value.maxRows = $event),
            min: 1,
            max: 999,
            class: "form-number"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "列合计（SUM）"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedField.value.summary || [], (sum, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-2 bg-slate-50 rounded-lg space-y-2"
            }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, "合计 " + _toDisplayString(index + 1), 1), _createVNode(_component_el_button, {
              type: "danger",
              link: "",
              size: "small",
              onClick: $event => removeSummary(index)
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])]), _createVNode(_component_el_select, {
              modelValue: sum.column,
              "onUpdate:modelValue": $event => sum.column = $event,
              placeholder: "选择数值列",
              size: "small",
              class: "w-full"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailNumericChildren(selectedField.value), col => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: col.key,
                  label: col.label,
                  value: col.key
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
              modelValue: sum.targetKey,
              "onUpdate:modelValue": $event => sum.targetKey = $event,
              placeholder: "合计值字段标识，如 totalAmount",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
              modelValue: sum.label,
              "onUpdate:modelValue": $event => sum.label = $event,
              placeholder: "合计标签，如 报销总额",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]);
          }), 128)), _createVNode(_component_el_button, {
            type: "primary",
            link: "",
            class: "w-full",
            disabled: !detailNumericChildren(selectedField.value).length,
            onClick: addSummary
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            }), _cache[34] || (_cache[34] = _createTextVNode(" 添加合计 ", -1))]),
            _: 1
          }, 8, ["disabled"]), !detailNumericChildren(selectedField.value).length ? (_openBlock(), _createElementBlock("p", _hoisted_59, " 请先在明细表内添加数字或金额列 ")) : _createCommentVNode("", true)])]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]),
        _: 1
      })])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: previewVisible.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => previewVisible.value = $event),
        title: "表单预览",
        width: "720px",
        class: "preview-dialog",
        "show-close": true,
        "close-on-click-modal": true,
        "destroy-on-close": ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createVNode(_component_el_icon, {
          class: "header-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(View))]),
          _: 1
        }), _cache[35] || (_cache[35] = _createElementVNode("span", {
          class: "header-title"
        }, "表单预览", -1))]), _cache[36] || (_cache[36] = _createElementVNode("div", {
          class: "header-tip"
        }, "以下为表单的实际展示效果", -1))])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = $event => previewVisible.value = false),
          class: "btn-close"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Close))]),
            _: 1
          }), _cache[40] || (_cache[40] = _createTextVNode(" 关闭预览 ", -1))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_62, [formFields.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_63, [_createVNode(_component_el_icon, {
          size: 56,
          class: "empty-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentAdd))]),
          _: 1
        }), _cache[37] || (_cache[37] = _createElementVNode("p", {
          class: "empty-text"
        }, "暂无表单字段", -1)), _cache[38] || (_cache[38] = _createElementVNode("p", {
          class: "empty-tip"
        }, "请先在左侧添加表单字段", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("h4", _hoisted_66, _toDisplayString(formName.value || '未命名表单'), 1), _createElementVNode("span", _hoisted_67, "共 " + _toDisplayString(formFields.value.length) + " 个字段", 1)]), _createVNode(_component_el_form, {
          "label-position": "top",
          class: "preview-form"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value, field => {
            return _openBlock(), _createElementBlock("div", {
              key: field.id,
              class: "form-field-item"
            }, [_createVNode(_component_el_form_item, {
              label: field.label,
              required: field.required,
              class: "field-label"
            }, {
              label: _withCtx(() => [_createElementVNode("span", _hoisted_68, [_createTextVNode(_toDisplayString(field.label) + " ", 1), field.required ? (_openBlock(), _createElementBlock("span", _hoisted_69, "*")) : _createCommentVNode("", true)])]),
              default: _withCtx(() => [field.placeholder ? (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(field.placeholder), 1)) : _createCommentVNode("", true), ['TEXT', 'EMAIL', 'PHONE', 'URL'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                placeholder: field.placeholder || `请输入${field.label}`,
                maxlength: field.maxLength,
                "show-word-limit": field.maxLength > 0,
                clearable: ""
              }, null, 8, ["placeholder", "maxlength", "show-word-limit"])) : ['NUMBER', 'MONEY'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 2,
                placeholder: field.placeholder,
                min: field.min,
                max: field.max,
                precision: field.type === 'MONEY' ? 2 : 0,
                class: "form-number"
              }, null, 8, ["placeholder", "min", "max", "precision"])) : field.type === 'TEXTAREA' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 3,
                type: "textarea",
                placeholder: field.placeholder || `请输入${field.label}`,
                rows: field.rows || 3,
                maxlength: field.maxLength,
                "show-word-limit": field.maxLength > 0,
                resize: "none"
              }, null, 8, ["placeholder", "rows", "maxlength", "show-word-limit"])) : field.type === 'DATE' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 4,
                type: "date",
                placeholder: field.placeholder || `请选择${field.label}`,
                class: "w-full form-date",
                format: "YYYY年MM月DD日",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["placeholder"])) : field.type === 'DATETIME' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 5,
                type: "datetime",
                placeholder: field.placeholder || `请选择${field.label}`,
                class: "w-full form-date",
                format: "YYYY年MM月DD日 HH:mm",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["placeholder"])) : field.type === 'SELECT' ? (_openBlock(), _createBlock(_component_el_select, {
                key: 6,
                placeholder: field.placeholder || `请选择${field.label}`,
                class: "w-full form-select",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["placeholder"])) : field.type === 'RADIO' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 7,
                class: "radio-group"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: opt.value,
                    label: opt.value,
                    class: "radio-item"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1024)) : field.type === 'CHECKBOX' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 8,
                class: "checkbox-group"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    key: opt.value,
                    label: opt.value,
                    class: "checkbox-item"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1024)) : field.type === 'FILE' ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 9,
                accept: field.accept || '*/*',
                limit: field.maxCount || 5,
                "max-size": (field.maxSize || 10) * 1024 * 1024,
                drag: "",
                multiple: "",
                action: "#",
                "auto-upload": false,
                class: "file-upload-wrapper"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createVNode(_component_el_icon, {
                  class: "upload-icon"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                  _: 1
                }), _cache[39] || (_cache[39] = _createElementVNode("div", {
                  class: "upload-text"
                }, [_createElementVNode("span", {
                  class: "primary"
                }, "拖拽文件到此处"), _createElementVNode("span", {
                  class: "secondary"
                }, "或"), _createElementVNode("em", null, "点击上传")], -1)), _createElementVNode("div", _hoisted_72, " 支持 " + _toDisplayString(field.accept || '所有文件') + " 格式，单个文件不超过 " + _toDisplayString(field.maxSize || 10) + "MB ", 1)])]),
                _: 2
              }, 1032, ["accept", "limit", "max-size"])) : field.type === 'SWITCH' ? (_openBlock(), _createBlock(_component_el_switch, {
                key: 10,
                disabled: ""
              })) : field.type === 'DETAIL' ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createElementVNode("p", _hoisted_74, " 明细表（" + _toDisplayString((field.children || []).length) + " 列）：" + _toDisplayString((field.children || []).map(c => c.label).join(' / ') || '尚未配置列'), 1)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["label", "required"])]);
          }), 128))]),
          _: 1
        })]))])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};